import { scrollPageToReviews } from './scroll-page-to-reviews';
import { navigate, hashParams } from '@otto-ec/global-resources/navigation';

export type HashParams = {
    scrollTo?: string;
};

export async function scrollToReviewsIfHashParamIsSet(reviewListElement: HTMLElement) {
    if (await reactToHashInURL()) {
        scrollPageToReviews(reviewListElement);
    }
}

async function reactToHashInURL() {
    const params = await hashParams<HashParams>(window.location.hash);

    const scrollToHash = params.get('scrollTo');
    if (scrollToHash !== 'reviews') {
        return false;
    }
    params.delete('scrollTo');
    await navigate(params.toUrl(), { history: 'replace' });
    return true;
}
